import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useLocation, useNavigate, Link } from 'react-router-dom'
import { viewSubAdminDetails } from '../../slice/subAdminSlice'
import moment from 'moment'
import { hasPermission } from '../../common/permissions'

const ViewSubAdminDetail = () => {
    const dispatch = useDispatch()
    const navigate = useNavigate()
    const location = useLocation()
    const { subAdminId } = location.state || {}

    const { subAdminDetail, loading } = useSelector(state => state.subAdmin)
    const [activeTab, setActiveTab] = useState('basic')

    useEffect(() => {
        if (subAdminId) {
            dispatch(viewSubAdminDetails({ id: subAdminId }))
        } else {
            navigate('/subadmins')
        }
    }, [dispatch, subAdminId, navigate])

    if (loading) {
        return (
            <div className="container-fluid px-4 py-3">
                <div className="d-flex justify-content-center align-items-center" style={{ minHeight: '400px' }}>
                    <div className="spinner-border text-primary" role="status">
                        <span className="visually-hidden">Loading...</span>
                    </div>
                </div>
            </div>
        )
    }

    if (!subAdminDetail) {
        return (
            <div className="container-fluid px-4 py-3">
                <div className="alert alert-warning">Sub-Admin not found</div>
            </div>
        )
    }

    const getPermissionBadge = (value) => {
        return value === 1 ? (
            <span className="badge bg-success">Yes</span>
        ) : (
            <span className="badge bg-secondary">No</span>
        )
    }

    return (
        <div className="container-fluid px-4 py-3">
            {/* Header */}
            <div className="d-flex justify-content-between align-items-center mb-4">
                <div className="d-flex align-items-center gap-3">
                    <button
                        onClick={() => navigate('/subadmins')}
                        className="btn btn-outline-secondary"
                        style={{
                            width: '36px',
                            height: '36px',
                            padding: '0',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            borderRadius: '6px'
                        }}
                    >
                        <i className="fe-arrow-left" style={{ fontSize: '16px' }} />
                    </button>
                    <h4 className="mb-0 fw-semibold">Sub-Admin Details</h4>
                </div>

                {/* {hasPermission('sub_admins', 'edit') && (
                    <Link
                        to="/subadmins/edit"
                        state={{ subAdminId }}
                        className="btn btn-primary"
                        style={{
                            padding: '8px 20px',
                            fontSize: '14px',
                            fontWeight: '500',
                            borderRadius: '6px'
                        }}
                    >
                        <i className="fe-edit me-2" style={{ fontSize: '14px' }} />
                        Edit Sub-Admin
                    </Link>
                )} */}
            </div>

            {/* Tabs */}
            <div className="card border-0 shadow-sm mb-3" style={{ borderRadius: '8px' }}>
                <div className="card-body p-0">
                    <ul className="nav nav-tabs" style={{ borderBottom: '1px solid #dee2e6' }}>
                        <li className="nav-item">
                            <button
                                className={`nav-link ${activeTab === 'basic' ? 'active' : ''}`}
                                onClick={() => setActiveTab('basic')}
                                style={{
                                    border: 'none',
                                    borderBottom: activeTab === 'basic' ? '2px solid #0d6efd' : '2px solid transparent',
                                    color: activeTab === 'basic' ? '#0d6efd' : '#6c757d',
                                    fontWeight: '500',
                                    padding: '12px 24px'
                                }}
                            >
                                Basic Information
                            </button>
                        </li>
                        <li className="nav-item">
                            <button
                                className={`nav-link ${activeTab === 'permissions' ? 'active' : ''}`}
                                onClick={() => setActiveTab('permissions')}
                                style={{
                                    border: 'none',
                                    borderBottom: activeTab === 'permissions' ? '2px solid #0d6efd' : '2px solid transparent',
                                    color: activeTab === 'permissions' ? '#0d6efd' : '#6c757d',
                                    fontWeight: '500',
                                    padding: '12px 24px'
                                }}
                            >
                                Permissions
                            </button>
                        </li>
                    </ul>
                </div>
            </div>

            {/* Basic Information Tab */}
            {activeTab === 'basic' && (
                <div className="card border-0 shadow-sm" style={{ borderRadius: '8px' }}>
                    <div className="card-body p-4">
                        <div className="row g-4">
                            <div className="col-md-6">
                                <div className="mb-3">
                                    <label className="text-muted small mb-1">User ID</label>
                                    <p className="mb-0 fw-semibold">{subAdminDetail.id || 'NA'}</p>
                                </div>
                            </div>

                            <div className="col-md-6">
                                <div className="mb-3">
                                    <label className="text-muted small mb-1">Email</label>
                                    <p className="mb-0 fw-semibold">{subAdminDetail.email || 'NA'}</p>
                                </div>
                            </div>

                            <div className="col-md-6">
                                <div className="mb-3">
                                    <label className="text-muted small mb-1">Role</label>
                                    <p className="mb-0 fw-semibold">{subAdminDetail.role || 'Sub-Admin'}</p>
                                </div>
                            </div>

                            <div className="col-md-6">
                                <div className="mb-3">
                                    <label className="text-muted small mb-1">Admin ID</label>
                                    <p className="mb-0 fw-semibold">{subAdminDetail.admin_id || 'NA'}</p>
                                </div>
                            </div>

                            <div className="col-md-6">
                                <div className="mb-3">
                                    <label className="text-muted small mb-1">Status</label>
                                    <div>
                                        <span className={`badge ${subAdminDetail.is_active === 1 ? 'bg-success' : 'bg-danger'}`}>
                                            {subAdminDetail.is_active === 1 ? 'Active' : 'Inactive'}
                                        </span>
                                    </div>
                                </div>
                            </div>

                            <div className="col-md-6">
                                <div className="mb-3">
                                    <label className="text-muted small mb-1">Account Status</label>
                                    <div>
                                        <span className={`badge ${subAdminDetail.is_deleted === 1 ? 'bg-danger' : 'bg-success'}`}>
                                            {subAdminDetail.is_deleted === 1 ? 'Deleted' : 'Active'}
                                        </span>
                                    </div>
                                </div>
                            </div>

                            <div className="col-md-6">
                                <div className="mb-3">
                                    <label className="text-muted small mb-1">Created Date</label>
                                    <p className="mb-0 fw-semibold">
                                        {subAdminDetail.createdAt
                                            ? moment(subAdminDetail.createdAt).local().format('DD MMM YYYY, hh:mm A')
                                            : 'NA'}
                                    </p>
                                </div>
                            </div>

                            <div className="col-md-6">
                                <div className="mb-3">
                                    <label className="text-muted small mb-1">Last Updated</label>
                                    <p className="mb-0 fw-semibold">
                                        {subAdminDetail.updatedAt
                                            ? moment(subAdminDetail.updatedAt).local().format('DD MMM YYYY, hh:mm A')
                                            : 'NA'}
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            )}

            {/* Permissions Tab */}
            {activeTab === 'permissions' && (
                <div className="card border-0 shadow-sm" style={{ borderRadius: '8px' }}>
                    <div className="card-body p-4">
                        <h5 className="mb-4 fw-semibold">Module Permissions</h5>

                        {subAdminDetail.permission && subAdminDetail.permission.length > 0 ? (
                            <div className="table-responsive">
                                <table className="table table-bordered">
                                    <thead className="table-light">
                                        <tr>
                                            <th style={{ width: '5%' }}>Sr No</th>
                                            <th style={{ width: '25%' }}>Module Name</th>
                                            <th style={{ width: '14%', textAlign: 'center' }}>View</th>
                                            <th style={{ width: '14%', textAlign: 'center' }}>Add</th>
                                            <th style={{ width: '14%', textAlign: 'center' }}>Edit</th>
                                            <th style={{ width: '14%', textAlign: 'center' }}>Delete</th>
                                            <th style={{ width: '14%', textAlign: 'center' }}>Status</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {subAdminDetail.permission.map((perm, index) => (
                                            <tr key={perm.id}>
                                                <td>{index + 1}</td>
                                                <td className="fw-semibold">
                                                    {perm.permission_module?.display_name || perm.permission_module?.name || 'NA'}
                                                </td>
                                                <td style={{ textAlign: 'center' }}>
                                                    {getPermissionBadge(perm.is_view)}
                                                </td>
                                                <td style={{ textAlign: 'center' }}>
                                                    {getPermissionBadge(perm.is_add)}
                                                </td>
                                                <td style={{ textAlign: 'center' }}>
                                                    {getPermissionBadge(perm.is_edit)}
                                                </td>
                                                <td style={{ textAlign: 'center' }}>
                                                    {getPermissionBadge(perm.is_delete)}
                                                </td>
                                                <td style={{ textAlign: 'center' }}>
                                                    {getPermissionBadge(perm.is_status)}
                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>
                        ) : (
                            <div className="text-center py-5">
                                <i className="fe-shield-off" style={{ fontSize: '48px', color: '#adb5bd' }}></i>
                                <h6 className="mt-3 mb-1 text-muted">No Permissions Assigned</h6>
                                <p className="text-muted small mb-0">This sub-admin has no module permissions</p>
                            </div>
                        )}

                        {/* Permission Summary */}
                        {subAdminDetail.permission && subAdminDetail.permission.length > 0 && (
                            <div className="mt-4 p-3 bg-light rounded">
                                <div className="row g-3">
                                    <div className="col-md-3">
                                        <div className="text-center">
                                            <h6 className="mb-1 text-muted small">Total Modules</h6>
                                            <h4 className="mb-0 fw-bold">{subAdminDetail.permission.length}</h4>
                                        </div>
                                    </div>
                                    <div className="col-md-3">
                                        <div className="text-center">
                                            <h6 className="mb-1 text-muted small">Can View</h6>
                                            <h4 className="mb-0 fw-bold text-primary">
                                                {subAdminDetail.permission.filter(p => p.is_view === 1).length}
                                            </h4>
                                        </div>
                                    </div>
                                    <div className="col-md-3">
                                        <div className="text-center">
                                            <h6 className="mb-1 text-muted small">Can Edit</h6>
                                            <h4 className="mb-0 fw-bold text-warning">
                                                {subAdminDetail.permission.filter(p => p.is_edit === 1).length}
                                            </h4>
                                        </div>
                                    </div>
                                    <div className="col-md-3">
                                        <div className="text-center">
                                            <h6 className="mb-1 text-muted small">Can Delete</h6>
                                            <h4 className="mb-0 fw-bold text-danger">
                                                {subAdminDetail.permission.filter(p => p.is_delete === 1).length}
                                            </h4>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        )}
                    </div>
                </div>
            )}
        </div>
    )
}

export default ViewSubAdminDetail;